import api from './client';

/**
 * Phase 38A · One-to-One calls — API client.
 *
 * See backend/routes/o2o.py for endpoint contracts. All calls require
 * a valid auth token (attached by `client.js` interceptor).
 */

// ── Creator availability CRUD ────────────────────────────────────────────

export const listMyO2OAvailability = async () => {
  const res = await api.get('/creators/me/o2o/availability');
  return res.data;
};

/**
 * @param {Object} payload — {day_of_week, start_time_hhmm, end_time_hhmm,
 *   slot_minutes, pause_minutes, price_cents, mode, timezone_iana}
 */
export const createO2OAvailability = async (payload) => {
  const res = await api.post('/creators/me/o2o/availability', payload);
  return res.data;
};

export const patchO2OAvailability = async (ruleId, patch) => {
  const res = await api.patch(`/creators/me/o2o/availability/${ruleId}`, patch);
  return res.data;
};

export const deleteO2OAvailability = async (ruleId) => {
  const res = await api.delete(`/creators/me/o2o/availability/${ruleId}`);
  return res.data;
};

// ── Public slot listing (used by user booking flow, Phase 38A.3) ─────────

export const listCreatorSlots = async (creatorId, { fromIso, toIso, onlyAvailable = false }) => {
  const res = await api.get(`/creators/${creatorId}/o2o/slots`, {
    params: { date_from: fromIso, date_to: toIso, only_available: onlyAvailable },
  });
  return res.data;
};

// ── Public creator O2O summary (Phase 38A.3) ─────────────────────────────

export const getCreatorO2OSummary = async (creatorId) => {
  const res = await api.get(`/creators/${creatorId}/o2o/summary`);
  return res.data;
};

// ── Booking (Phase 38A.3) ────────────────────────────────────────────────

export const bookO2OSlot = async (creatorId, { slotStartUtc, originUrl = null, consentAccepted = false }) => {
  const payload = {
    slot_start_utc: slotStartUtc,
    consent_accepted: !!consentAccepted,
  };
  if (originUrl) payload.origin_url = originUrl;
  const res = await api.post(`/creators/${creatorId}/o2o/book`, payload);
  return res.data;
};

// ── Disputes (Phase 38A.5) ───────────────────────────────────────────────

export const getDisputeEligibility = async (o2oSessionId) => {
  const res = await api.get(`/o2o/sessions/${o2oSessionId}/dispute/eligibility`);
  return res.data;
};

export const openO2ODispute = async (o2oSessionId, { reason, description, evidenceUrls = [] }) => {
  const res = await api.post(`/o2o/sessions/${o2oSessionId}/dispute`, {
    reason,
    description,
    evidence_urls: evidenceUrls,
  });
  return res.data;
};

export const getO2ODispute = async (o2oSessionId) => {
  const res = await api.get(`/o2o/sessions/${o2oSessionId}/dispute`);
  return res.data;
};

export const getO2OSessionStatus = async (o2oSessionId) => {
  const res = await api.get(`/o2o/sessions/${o2oSessionId}/status`);
  return res.data;
};

export const listMyO2OSessions = async (role = 'user') => {
  const res = await api.get('/o2o/sessions/mine', { params: { role } });
  return res.data;
};
